// tuning/spaces.ts (M0-T06, §7.2) — interior layouts in room tile space (x east, y south; door on the south wall at y = h − 1).
// Read by the server (M0-T14 bounds + spawn, M1-T07 counter range, M2-T05 curator range) and the client scenes (M1-T14, M2-T10).
import type { TuningBank } from '../schema/tuning';

export default {
  shop: { w: 8, h: 6, door: [4, 5], counter: [2, 1, 4, 1], shopkeeper: [4, 0.5], loanDesk: [7, 2] },          // counter = [x, y, w, h]
  museum: { w: 16, h: 12, door: [8, 11], curator: [8, 8], fossilHall: [0, 0, 8, 7], aquarium: [8, 0, 8, 7],   // halls = [x, y, w, h]
    // the aquarium's tanks: [x, y, w, d] from the aquarium's corner (M2-T10; G6: read by the client scene, so this moves them)
    tanks: { river: [1, 0.4, 2.6, 1.2], pond: [4.2, 0.4, 2.6, 1.2], sea: [1, 3, 3, 1.6], feature: [4.4, 2.8, 3.2, 2.6] } },
} as const satisfies TuningBank;
